import mixins from 'vue-typed-mixins';

import 計画書Mixin from '@/entries/user/mixins/計画書Mixin';
import 事業所Mixin from '@/entries/user/mixins/事業所Mixin';
import { TOldLoan, TデータOldLoan, 返済明細 } from '@/classes/service/計画/返済明細Service';
import { KeyOldLoan } from '@/classes/service/AbstractPlbscfService';
import { データListItemRequest, E入力分類, Eフェーズ種別, データRequest } from '@/openapi/user';

export default mixins(計画書Mixin, 事業所Mixin).extend({
  name: 'M償却ListMixin',

  data(): {
    oldLoans: TOldLoan;
    hasOldLoans: boolean;
  } {
    return {
      oldLoans: {
        短期: Array(14).fill(0),
        長期: Array(14).fill(0),
        役員: Array(14).fill(0),
        year: 0,
      },
      hasOldLoans: false,
    };
  },

  methods: {
    getOldLoans(oldData: TデータOldLoan, v返済明細: 返済明細): void {
      if (!oldData) {
        this.hasOldLoans = false;
        v返済明細?.tables.forEach((item) => {
          const type = item.type.replace('借入金返済予定表', '') as KeyOldLoan;
          this.oldLoans[type] = Array(14).fill(0);
          item.list[item.list.length - 1].cells.forEach((cell, i) => {
            if (i >= 3) {
              this.oldLoans[type][i - 3] = cell?.ymInput?.value ?? Number(cell?.fix);
            }
          });
        });
        this.oldLoans.year = v返済明細?.v決算期.years[0].year;
      } else {
        this.hasOldLoans = true;
      }
    },
    updateRequestBulkSave(データRequests: データListItemRequest[]): void {
      if (!this.hasOldLoans) {
        データRequests.push({
          c入力分類: E入力分類.OLDLOAN,
          c番号: 0,
          cフェーズ種別: Eフェーズ種別.計画フェーズ,
          cデータ: JSON.stringify(this.oldLoans),
        });
      }
    },
    updateRequestSave(request: データRequest): void {
      if (!this.hasOldLoans) {
        request.oldLoan = JSON.stringify(this.oldLoans);
      }
    },
  },
});
